import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND, NAV_ITEMS, COLORS } from '../../data/siteData';
import { Menu, X } from 'lucide-react';

const Header = ({ onDemoClick, scrollToSection, isTransparent = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (item, e) => {
    if (item.href.startsWith('#')) {
      e.preventDefault();
      if (location.pathname !== '/') {
        window.location.href = '/' + item.href;
      } else {
        scrollToSection(item.href.substring(1));
      }
      setMobileMenuOpen(false);
    }
  };

  const headerBg = isTransparent && !scrolled 
    ? 'bg-transparent' 
    : 'bg-white shadow-sm';

  const textColor = isTransparent && !scrolled 
    ? 'text-white' 
    : '';

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${headerBg}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src={BRAND.logo} 
              alt={BRAND.name} 
              className="h-10 w-auto"
            />
            <span className={`text-xl font-bold transition-colors duration-300 ${textColor}`} style={{ color: isTransparent && !scrolled ? '#fff' : COLORS.dark }}>
              {BRAND.name}<span style={{ color: COLORS.red }}>®</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {NAV_ITEMS.map((item, index) => (
              item.href.startsWith('/') ? (
                <Link
                  key={index}
                  to={item.href}
                  className={`text-sm font-medium transition-colors hover:opacity-70 ${textColor}`}
                  style={{ color: isTransparent && !scrolled ? '#fff' : COLORS.dark }}
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={index}
                  href={item.href}
                  onClick={(e) => handleNavClick(item, e)}
                  className={`text-sm font-medium transition-colors hover:opacity-70 ${textColor}`}
                  style={{ color: isTransparent && !scrolled ? '#fff' : COLORS.dark }}
                >
                  {item.label}
                </a>
              )
            ))}
            <button
              onClick={onDemoClick}
              className="px-5 py-2.5 text-sm font-medium text-white rounded-lg transition-all hover:opacity-90"
              style={{ backgroundColor: COLORS.green }}
              data-testid="header-demo-btn"
            >
              Prašyti demonstracijos
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" style={{ color: isTransparent && !scrolled ? '#fff' : COLORS.dark }} />
            ) : (
              <Menu className="h-6 w-6" style={{ color: isTransparent && !scrolled ? '#fff' : COLORS.dark }} />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100 bg-white rounded-b-lg">
            <nav className="flex flex-col space-y-4">
              {NAV_ITEMS.map((item, index) => (
                item.href.startsWith('/') ? (
                  <Link
                    key={index}
                    to={item.href}
                    className="text-sm font-medium py-2"
                    style={{ color: COLORS.dark }}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    key={index}
                    href={item.href}
                    onClick={(e) => handleNavClick(item, e)}
                    className="text-sm font-medium py-2"
                    style={{ color: COLORS.dark }}
                  >
                    {item.label}
                  </a>
                )
              ))}
              <button
                onClick={() => {
                  onDemoClick();
                  setMobileMenuOpen(false);
                }}
                className="px-5 py-2.5 text-sm font-medium text-white rounded-lg w-full"
                style={{ backgroundColor: COLORS.green }}
              >
                Prašyti demonstracijos
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
